export default "__VITE_ASSET__C$g5_gJt__"